<script>
  import { setPageReferrer } from '../stores/referrer';

  let { referrer } = $props();

  setPageReferrer(referrer);
</script>
